import { Theme } from '../../models/system/theme';

/**
 * Theme "Roadx". Reference to setting in table dbo.Theme.
 */
export const Theme_Roadx: Theme = {
  name: 'Roadx', // Same as value of field "Code" in table dbo.Theme.
  properties: {
    /* own color */
    '--mainColor': '#000000', // Color 2
    '--mainButtomColor': '#000000', // main Buttom
    '--minorColor': '#E72838', // Color 3
    '--mainColorB':'#000000',
    '--subColor': '#000000', // Color 1.
    '--mainBackgroundColor': '#777B84', // Background
    '--mainTitleColor':'#f2f4f9',
    '--minorBackgroundColor': '#FFFFFF', // NAV
    '--importantLabel': '#333',
    '--ordinary_label': '#666',
    '--nonImportantLabel': '#999',
    '--dashColor1': '#abb5c4',
    '--dashColor2': '#777B84',
    '--controlColor_span1': '#1F2125',
    '--controlInptBackgroundColor1': '#f3f2f2',
    '--navTitleColor': '#FFFFFF',
    '--navTitleMinorColor': '#FFFFFF',

    '--extraPriceColor':'#287f3d',   
    '--inTransitColor':'#0435c5', 
    '--cartIconColor':'#FFFFFF',  
    '--grid_th_Color': '#F6F6F6',
    '--grid_td_Color': '#FFFFFF',


    /*hearder*/
    '--navbarBackground': '#000000',
    '--headerClickColor': '#000000',
    '--headerClickColor_border': '#090e2126',

    /*order*/
    '--controlColor_order_buttom1': '#000000',
    '--controlColor_order_buttom2': '#E72838',
    '--controlColor_order_buttom3': '#000000',
    '--controlColor_order_buttom4': '#E72838',
    '--controlColor_buttomBorder1': '#E72838',

    /*cart*/
    '--grid_thColor': '#F6F6F6',
    '--controlColor_buttom2': '#090E22',
    '--controlColor_buttom3': '#000000',
    '--controlColor_buttom2_font': '#FFFFFF',
    '--dialogBackgroundColor': '#FFFFFF',

    '--noFillColor':'#62697b',
    '--disableCarat':"#ccc",

     /*Direct Container Order Grid */
     '--GridRightBorderTH': 'B3B2B3',
     '--GridRightBorderTD': '#CCC',
     '--GridHoverColorTR': '#F09BA2',
     '--TextOnHover': '#FFFFFF'

    /* Bootstrap css override */
   }
};
